<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';

import { dataMaster } from '@/config/constants';
import { checkPermission } from '@/utils/handlers';

export default {
    page: {
        title: 'その他管理一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout
    },
    data() {
        return {
            data: dataMaster
        };
    },
    mounted() {},
    methods: {
        goToEdit(path, key) {
            this.$router.push({ path: path, query: { key: key } });
        },
        checkPermiss(listRole) {
            return checkPermission(listRole);
        }
    }
};
</script>

<template>
    <Layout>
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table mb-0 table-bordered">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>カテゴリ</th>
                                    <th>マスター名</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item, k) in data">
                                    <template>
                                        <tr :key="item.key">
                                            <th scope="row" :rowspan="item.rowspan">{{ k + 1 }}</th>
                                            <td :rowspan="item.rowspan">{{ item.name }}</td>
                                            <td v-if="item.childMain !== ''">{{ item.childMain }}</td>
                                            <td v-if="item.childMain !== ''">
                                                <a
                                                    href="javascript:void(0)"
                                                    class="btn btn-common-sml btn-info"
                                                    @click="goToEdit('/master/other/form', item.key + '.' + item.keyMain)"
                                                    ><i class="ri-file-list-2-line"></i>詳細</a
                                                >
                                            </td>
                                        </tr>
                                        <tr v-for="(child, cI) in item.child" :key="cI">
                                            <td v-if="child.name !== ''">{{ child.name }}</td>
                                            <td v-if="child.name !== ''">
                                                <a
                                                    href="javascript:void(0)"
                                                    class="btn btn-common-sml btn-info"
                                                    @click="goToEdit('/master/other/form', item.key + '.' + child.key)"
                                                    ><i class="ri-file-list-2-line"></i>詳細</a
                                                >
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
td,
th {
    vertical-align: middle;
}
</style>
